The tooltip label to indicate candidate identity has been verified.
